import React from 'react'
import type { ComponentProps, PartData } from '@enonic/react-components'
import LogoBar from '/react4xp/components/prototype/LogoBar'

type ClientLogoBarLogo = {
	src: string
	alt: string
}

type ClientLogoBarPartData = {
	heading?: string
	logos?: ClientLogoBarLogo[]
}

export const ClientLogoBar = ({ data }: ComponentProps<PartData>) => {
	const { heading, logos = [] } = (data || {}) as ClientLogoBarPartData

	return <LogoBar heading={heading} logos={logos} />
}
